import styled from 'styled-components'
import { AlertTriangle } from 'react-feather'
import HouseSidingIcon from '@mui/icons-material/HouseSiding'
import theme from 'src/styles/theme'

export const Icon = styled(AlertTriangle)`
  color: white;
  margin-right: 1.6rem;
  width: 26px;
  height: 30px;
`

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 10px 40px;
`

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-around;
  flex: 1 1 100%;
  margin: 1rem 0 0.5rem;
`

export const Form = styled.form`
  margin: 0;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 16px;
  border-left: 3px solid ${theme.colors.blue};
`

export const GridContainer = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: ${({ columns }) => `repeat(${columns || 1}, 1fr)`};
  gap: 16px;
  padding-left: 8px;
  margin: 16px 0px;
  align-items: center;
`

export const HouseIcon = styled(HouseSidingIcon)`
  color: ${theme.colors.white} !important;
`
